export default "__VITE_ASSET__PGxEN5Yw__"